export const environment = {
  production: true,
  Title: 'FloIndex',
  DefaultReturnUrl: '/home',
  CurrentUserKey: 'FLOCurrentUser',
  AuthApiEndPoint: 'https://metrium.live/api/auth',
  MqttApiEndPoint: 'http://15.206.138.184:7004/api/mqtt',
  UserApiEndPoint: 'https://metrium.live/api/user',
  DeviceApiEndPoint: 'https://metrium.live/api/device',
  AccessTokenKeyLabel: 'FLOAccessToken',
  RefreshTokenKeyLabel: 'FLORefreshToken',
  DeviceSocketEndPoint: 'https://metrium.live/api/device',
  DashboardWidgetRealTimeEvent: 'dashboardWidgetRealTimeEvent',
  DefaultRetrunUrlForMasterAdmin: '/project/list',
  AwsS3BucketUrl:
    'https://floindex-staging-public.s3.ap-south-1.amazonaws.com/',
  DefaultCountryCode: '91',
  GoogleClientId:
    '81022679053-7kv1usm0mm8dr5r75lh1ddc5mhogcln5.apps.googleusercontent.com',
  DefaultProfileImage: '../../assets/images/user.png',
};
